import { render, staticRenderFns } from "./classBtn.vue?vue&type=template&id=18a27e39&scoped=true&"
import script from "./classBtn.vue?vue&type=script&lang=js&"
export * from "./classBtn.vue?vue&type=script&lang=js&"
import style0 from "./classBtn.vue?vue&type=style&index=0&id=18a27e39&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a27e39",
  null
  
)

export default component.exports